import { Button, ButtonProps, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

type BackLinkProps = {
  to: string;
  children?: React.ReactNode | string;
};

export const BackLink: React.FC<BackLinkProps & ButtonProps> = ({
  to,
  children = "Back",
  ...props
}) => {
  const navigate = useNavigate();

  return (
    <Button
      onClick={() => navigate(to)}
      startIcon={<ArrowBackIcon />}
      variant="outlined"
      {...props}
    >
      <Typography variant="body1">{children}</Typography>
    </Button>
  );
};
